import axios from 'axios';
import { API_URL } from '../constants/urls';

export interface OrganizationArea {
  id: string;
  organization_id: string;
  name: string;
  description?: string;
  value: string;
  color?: string;
  icon?: string;
  is_active: boolean;
  is_default: boolean;
  display_order: number;
  created_at: string;
  updated_at: string;
  created_by_id?: string;
  created_by_name?: string;
}

export interface AreaFormData {
  name: string;
  description: string;
  value: string;
  color: string;
  icon: string;
  is_active: boolean;
  display_order: number;
}

export const areasService = {
  async initializeDefaults(
    organizationId: string,
  ): Promise<OrganizationArea[]> {
    const response = await axios.post(
      `${API_URL}/areas/initialize-defaults?organization_id=${organizationId}`,
    );
    return response.data;
  },

  async list(
    organizationId: string,
    includeInactive = false,
  ): Promise<OrganizationArea[]> {
    const response = await axios.get(
      `${API_URL}/areas?organization_id=${organizationId}&include_inactive=${includeInactive}`,
    );
    return response.data;
  },

  async create(
    organizationId: string,
    data: AreaFormData,
  ): Promise<OrganizationArea> {
    const response = await axios.post(
      `${API_URL}/areas?organization_id=${organizationId}`,
      data,
    );
    return response.data;
  },

  async update(
    organizationId: string,
    areaId: string,
    data: Partial<AreaFormData>,
  ): Promise<OrganizationArea> {
    const response = await axios.put(
      `${API_URL}/areas/${areaId}?organization_id=${organizationId}`,
      data,
    );
    return response.data;
  },

  async delete(organizationId: string, areaId: string): Promise<any> {
    return await axios.delete(
      `${API_URL}/areas/${areaId}?organization_id=${organizationId}`,
    );
  },
};
